import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { protectSheetWithRandomPassword } from "../ExcelUtils";

function loanPendingInstallmentExcel(data, branchName, startDate, endDate, activeStatus = "", product, loginPlaceId) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Loan Report');

    // Define column headers
    const columns = [
        { header: 'No', key: 'no', width: 8 },   // ✅ NEW
        { header: 'Was Name', key: 'wasName', width: 15 },
        { header: 'Acc Number', key: 'accNumber', width: 20 },
        { header: 'Loan No', key: 'loanNo', width: 20 },
        { header: 'Cus No', key: 'cusNo', width: 15 },
        { header: 'Name', key: 'name', width: 20 },
        { header: 'Per Address', key: 'perAddress', width: 30 },
        { header: 'No of Installment', key: 'nopInstallment', width: 15 },
        { header: 'Total Penalty', key: 'totalPenalty', width: 15 },
        { header: 'Total Interest Amount', key: 'totalInterestAmount', width: 20 },
        { header: 'Total Capital Amount', key: 'totalCapitalAmount', width: 20 },
        { header: 'Total Amount', key: 'totalAmount', width: 15 },
        { header: 'Remaining', key: 'remaining', width: 15 },
    ];

    worksheet.addRow(['Branch: ' + branchName]);
    worksheet.addRow([startDate || ""]);
    worksheet.addRow([endDate || ""]);
    worksheet.addRow(['Loan Pending Installment Report ' + activeStatus]);
    worksheet.addRow(['Product: ' + product]);
    worksheet.addRow(['printed Date: ' + new Date().toLocaleDateString()]);
    worksheet.addRow([]);

    const headerRow = worksheet.addRow(columns.map(col => col.header));
    headerRow.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0000FF' } };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    });

    data.sort((a, b) => a.wasName.localeCompare(b.wasName));

    const groupedData = data.reduce((acc, item) => {
        if (!acc[item.wasName]) acc[item.wasName] = [];
        acc[item.wasName].push(item);
        return acc;
    }, {});

    let rowIndex = worksheet.rowCount + 1;
    let isEvenRow = false;
    const subtotalRows = [];
    let serialNo = 1;   // ✅ counter

    Object.keys(groupedData).forEach(wasName => {
        const group = groupedData[wasName];
        const groupStartRow = rowIndex;

        group.forEach(item => {
            const row = worksheet.addRow([
                serialNo++,   // ✅ No column
                item.wasName,
                item.accNumber,
                item.loanNo,
                item.cusNo,
                item.name,
                item.perAddress,
                item.nopInstallment,
                item.totalPenalty,
                item.totalInterestAmount,
                item.totalCapitalAmount,
                item.totalAmount,
                item.remaining,
            ]);

            row.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: isEvenRow ? 'FFF0F0F0' : 'FFFFFFFF' }
                };
            });

            isEvenRow = !isEvenRow;
            rowIndex++;
        });

        const groupEndRow = rowIndex - 1;

        // ✅ fixed column letters after adding No column
        const subtotalRow = worksheet.addRow([
            ``,
            `Subtotal for ${wasName}`, '', '', '', '', '', '',
            { formula: `SUM(I${groupStartRow}:I${groupEndRow})` },
            { formula: `SUM(J${groupStartRow}:J${groupEndRow})` },
            { formula: `SUM(K${groupStartRow}:K${groupEndRow})` },
            { formula: `SUM(L${groupStartRow}:L${groupEndRow})` },
            { formula: `SUM(M${groupStartRow}:M${groupEndRow})` }
        ]);

        subtotalRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
            cell.font = { bold: true };
        });

        subtotalRows.push(rowIndex);
        rowIndex++;
    });

    const subtotalRowRefs = subtotalRows.join(',');

    const grandTotalRow = worksheet.addRow([
        '',
        'Grand Total', '', '', '', '', '', '',
        { formula: `SUM(${subtotalRows.map(row => `I${row}`).join(',')})` },
        { formula: `SUM(${subtotalRows.map(row => `J${row}`).join(',')})` },
        { formula: `SUM(${subtotalRows.map(row => `K${row}`).join(',')})` },
        { formula: `SUM(${subtotalRows.map(row => `L${row}`).join(',')})` },
        { formula: `SUM(${subtotalRows.map(row => `M${row}`).join(',')})` }
    ]);

    grandTotalRow.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF0000' } };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    });

    columns.forEach((col, index) => {
        if (index === 1) {
            worksheet.getColumn(index + 1).width = 50;
        } else {
            worksheet.getColumn(index + 1).width = col.width;
        }
    });

    [9, 10, 11, 12, 13].forEach(colIndex => {
        worksheet.getColumn(colIndex).numFmt = '#,##0.00';
    });



    if (loginPlaceId === "1") {
        const password = protectSheetWithRandomPassword(worksheet, 12);
    }

    worksheet.views = [{ state: "frozen", xSplit: 4, ySplit: 8 }];

    workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, `Loan_Report_${branchName}.xlsx`);
    });
}

export default loanPendingInstallmentExcel;
